// We use https://github.com/salemdar/ngx-cookie, refer to the API docs there.
export { CookieModule, CookieService } from 'ngx-cookie';



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build/webapp/src/app/@shared/cookie/index.ts